var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"content fColor1"},[_c('div',{staticClass:"totalcount"},[_vm._v(_vm._s(_vm.$t('asset.commissionLibrary'))+"："+_vm._s(_vm.amount))])])])}
var staticRenderFns = []

export { render, staticRenderFns }